import { MULTI_COLUMN_SEPARATOR } from "consts/filters";
import { concat } from "./support";

export function splitWithModifier(value: string, separator = ':') {
    return value.split(separator);
}

export function booleanFilterFactory([falsyLabel, truthyLabel]: [string, string]) {
    return [
        { id: 0, name: falsyLabel },
        { id: 1, name: truthyLabel }
    ];
}

export const multiColumnFilterFactory = <T extends string>(columnCollection: Array<T>) =>
    concat(columnCollection, { token: MULTI_COLUMN_SEPARATOR });
